import React, {useEffect, useRef, useState} from 'react';
import GoogleMapReact from "google-map-react";
import PropTypes from "prop-types";
import Marker from "./Marker";

function Map ({mapData, selectedMapExcursion, setSelectedMapExcursion, handleBoundChange}) {
    const [filteredMarkers, setFilteredMarkers] = useState([]);
    const mapRef = useRef(null);
    const lastBoundsRef = useRef(null);
    const hasFittedRef = useRef(false);

    const defaultMapValues = {
        center: {
            lat: 60.0,
            lng: 15.0
        },
        zoom: 4,
        bounds: {
            nw: { lat: 71.0, lng: -25.0 },
            ne: { lat: 71.0, lng: 45.0 },
            sw: { lat: 54.0, lng: -25.0 },
            se: { lat: 54.0, lng: 45.0 }
        }
    };

    const handleMapChange = (event) => {
        if (!hasFittedRef.current) {
            // Ignore the synthetic bounds event GoogleMapReact fires on initial
            // load (the hardcoded default viewport) before we've had a chance
            // to fit the view to the current markers. Forwarding it can filter
            // against markers belonging to a previous, stale mapData state.
            return;
        }

        const currentBounds = event.bounds;
        lastBoundsRef.current = currentBounds;
        handleBoundChange(currentBounds);
    };

    useEffect(() => {
        if (selectedMapExcursion !== null){
            zoomAndPanToCoordinate(selectedMapExcursion.coordinates.lat, selectedMapExcursion.coordinates.lng);
        }
    }, [selectedMapExcursion]);


    const zoomAndPanToCoordinate = (lat, lng, zoomNumber = 9) => {
        if (mapRef.current !== null) {
            mapRef.current.panTo({lat: parseFloat(lat), lng: parseFloat(lng)});
            mapRef.current.setZoom(zoomNumber);
        }
    }

    const fitBoundsToMarkers = () => {
        if (mapRef.current && filteredMarkers.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();

            filteredMarkers.forEach(point => {
                bounds.extend(new window.google.maps.LatLng(point.coordinates.lat, point.coordinates.lng));
            });

            hasFittedRef.current = true;
            mapRef.current.fitBounds(bounds);
        }
    };

    const resetMapSelection = () => {
        selectedMapExcursion !== null && setSelectedMapExcursion(null);

        if (filteredMarkers.length > 0) {
            fitBoundsToMarkers();
        }
    };


    useEffect(() => {
        if (mapData.length > 0) {
            const filterNullCoordinates = mapData.filter(data => data.coordinates !== null);

            if (filterNullCoordinates.length > 0) {
                setFilteredMarkers(filterNullCoordinates);
            }

            if (lastBoundsRef.current) {
                handleBoundChange(lastBoundsRef.current);
            }
        } else {
            setFilteredMarkers([]);
        }
    }, [mapData]);


    useEffect(() => {
        if (filteredMarkers.length > 0 || (mapRef.current === null && window.google)) {
            fitBoundsToMarkers();
        }
    }, [filteredMarkers, mapRef.current]);

     return (
         <div style={{ position: 'relative', height: '524px', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{key: "AIzaSyDyFZ9o7gYhsKcwiLOtKtnyRxMnkQcVztM"}}
                defaultCenter={defaultMapValues.center}
                defaultZoom={defaultMapValues.zoom}
                options={{fullscreenControl: false, maxZoom: 9}}
                onClick={resetMapSelection}
                onChange={handleMapChange}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map }) => {
                    mapRef.current = map;
                    fitBoundsToMarkers();
                }}
            >

                {filteredMarkers.map((point, index) =>
                    <Marker
                        key={index}
                        lat={parseFloat(point.coordinates.lat)}
                        lng={parseFloat(point.coordinates.lng)}
                        count={point.count}
                        onClick={() => setSelectedMapExcursion(point)}
                        selected={selectedMapExcursion !== null && selectedMapExcursion.uid === point.uid}
                    />
                )}
            </GoogleMapReact>
             {mapData.length === 0 && (
                 <div style={{
                     position: 'absolute',
                     top: 0,
                     left: 0,
                     right: 0,
                     bottom: 0,
                     backgroundColor: 'rgba(255, 255, 255, .4)',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     zIndex: 10
                 }}>
                 </div>
             )}
        </div>
    )

}

Map.propTypes = {
    excursionListRef: PropTypes.func,
    mapData: PropTypes.array,
    selectedMapExcursion: PropTypes.object,
    setSelectedMapExcursion: PropTypes.func,
    onBoundsChange: PropTypes.func
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Planner/Map.js